import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  text: {
    marginTop: `${theme.spacing(4)} !important`,
  },
  listItemText: {
    flexGrow: '1 !important',
  },
  editButton: {
    marginLeft: `${theme.spacing(2)} !important`,
  },
  primaryText: {
    display: 'inline-block',
    verticalAlign: 'middle',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    lineHeight: '1em',
  },
  icon: {
    minWidth: '48px !important',
    [theme.breakpoints.down('sm')]: {
      minWidth: '42px !important',
      marginLeft: `${theme.spacing(-3)} !important`,
    },
  },
  item: {
    [theme.breakpoints.down('sm')]: {
      paddingRight: '0 !important',
    },
  },
}))
